export function compareDates(srcInputDate: any, destInputdate: any, operat: any): Boolean {
    if (operat == '>=') {
        if (destInputdate >= srcInputDate) {
            return true
        } else {
            return false;
        }
    } else if (operat == '>') {
        if (destInputdate > srcInputDate) {
            return true
        } else {
            return false;
        }
    } else {
        return false;
    }

}